const STORAGE_KEY = 'publishy_operator_scope_id';

const buildFallbackId = () => (
  `op_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`
);

export const getOperatorScopeId = () => {
  if (typeof window === 'undefined') return '';
  try {
    const existing = String(window.localStorage.getItem(STORAGE_KEY) || '').trim();
    if (existing) return existing;
    const next = (typeof window.crypto?.randomUUID === 'function')
      ? `op_${window.crypto.randomUUID()}`
      : buildFallbackId();
    window.localStorage.setItem(STORAGE_KEY, next);
    return next;
  } catch (_) {
    return buildFallbackId();
  }
};

